interface CardPlaceholderProps {
  width?: number
  height: number
}

export default function CardPlaceholder({
  width,
  height,
}: CardPlaceholderProps) {
  return (
    <div
      className="animate-pulse bg-zinc-700"
      style={{
        width: width ? `${width}px` : '100%',
        height: height ? `${height}px` : '',
      }}
    />
  )
}
